import { createSlice } from "@reduxjs/toolkit";
import { fetchProductOffers } from "../actions/ProductsOfferActions";

const offersSlice = createSlice({
  name: "offers",
  initialState: {
    offers: [], 
    pagination: {}, 
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductOffers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProductOffers.fulfilled, (state, action) => {
        //console.log('=== Offers Slice - Fulfilled ==='); // تسجيل نجاح جلب عروض المنتجات
        //console.log('Action payload:', action.payload); // تسجيل بيانات الاستجابة
        //console.log('Action payload.data:', action.payload.data); // تسجيل بيانات العروض
        //console.log('Action payload.pagination:', action.payload.pagination); // تسجيل معلومات الصفحات
        
        state.isLoading = false;
        state.offers = action.payload.data;
        state.pagination = action.payload.pagination; // pagination on fulfilled
        
        //console.log('State after update:', state); // تسجيل الحالة بعد التحديث
      })
      .addCase(fetchProductOffers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  },
});

export default offersSlice.reducer;
